import React, { useEffect, useState, useRef, useCallback } from "react";
import { useLoading } from "../../context/LoadingContext";
import "./SuperAdminModule.scss";
import gsap from "gsap";
import { FaFilter } from "react-icons/fa6";
import { FaSearch } from "react-icons/fa";
import {
  dcScrapingSync,
  deleteCompany,
  deletePlan,
  deleteUserBySuperAdmin,
  getAllCompaniesForSuperAdmin,
  getAllExistPlans,
  getAllUsersForSuperAdmin,
  getDcScrapingStatus,
  getHcScrapingStatus,
  hcScrapingSync,
  SearchGetAllCompaniesForSuperAdmin,
  SearchGetAllUsersForSuperAdmin,
  updateCompanyBySuperAdmin,
  updateUserBySuperAdmin,
} from "../../services/api/SuperAdminApi";
import { useLocation, useNavigate } from "react-router-dom";
import ConfirmationModal from "../../components/Modal/ConfirmModal";
import DeleteConfirmationModal from "../../components/DeleteConfirmationModal/DeleteConfirmationModal";
import { IoGrid } from "react-icons/io5";
import { FaTableList } from "react-icons/fa6";
import { BiEdit, BiTrash } from "react-icons/bi";
import { MdAccountBalance } from "react-icons/md";
import { FaUniversity } from "react-icons/fa";
import { FaFileAlt } from "react-icons/fa";
import CompanySelectionModal from "../../components/CompanySelectionModal/CompanySelectionModal";
import CompanyLimitModal from "../../components/CompanyModalLimit/CompanyModalLimit";

export const SuperAdminModule = () => {
  const { showLoading, hideLoading } = useLoading();

  const navigate = useNavigate();

  const [viewMode, setViewMode] = useState("table");
  const [plans, setPlans] = useState([]);
  const [users, setUsers] = useState([]);
  const [companies, setCompanies] = useState([]);

  const [isCompanyModalOpen, setIsCompanyModalOpen] = useState(false);
  const [isCompanySelectionModalOpen, setIsCompanySelectionModalOpen] = useState(false);
  const [selectedCompanyForManage, setSelectedCompanyForManage] = useState(null);
  const [persistedSelectedRefs, setPersistedSelectedRefs] = useState(new Set());


  // Remove local loading state, use global loading context
  const [dataLoaded, setDataLoaded] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  // For delete modal
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    type: "",
    id: null,
  });
  // For status modal
  const [statusModal, setStatusModal] = useState({
    isOpen: false,
    companyId: null,
    currentStatus: false,
  });
  // For user status modal
  const [userStatusModal, setUserStatusModal] = useState({
    isOpen: false,
    userId: null,
    currentStatus: false,
  });
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [syncingCompanies, setSyncingCompanies] = useState(new Set());

  const [processingCompanies, setProcessingCompanies] = useState(new Set());
  const [showStatusTooltip, setShowStatusTooltip] = useState(null);

  // Add district court modal and sync states
  const [isDistrictCourtModalOpen, setIsDistrictCourtModalOpen] =
    useState(false);
  const [syncingDistrictCourtCompanies, setSyncingDistrictCourtCompanies] =
    useState(new Set());
  const [
    processingDistrictCourtCompanies,
    setProcessingDistrictCourtCompanies,
  ] = useState(new Set());

  // Accordion state
  const [expandedCards, setExpandedCards] = useState(new Set());
  const expandableRefs = useRef({});

  const [showSearchInput, setShowSearchInput] = useState(false);
  const [sasearchQuery, setSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);

  const sasearchInputRef = useRef(null);
  const searchButtonRef = useRef(null);
  const sasearchContainerRef = useRef(null);

  // Scroll indicator refs
  const tableContainerRef = useRef(null);
  const tableWrapperRef = useRef(null);
  const leftScrollIndicatorRef = useRef(null);
  const rightScrollIndicatorRef = useRef(null);
  const topScrollbarRef = useRef(null);
  const topScrollbarContentRef = useRef(null);

  // Horizontal scroll indicator state for companies table
  const [isCompaniesTableScrollable, setIsCompaniesTableScrollable] = useState(false);

  // Filter states
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [filteredPlans, setFilteredPlans] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [planFilters, setPlanFilters] = useState({
    type: "all",
    priceRange: "all",
    duration: "all",
    casesLimit: "all",
    usersLimit: "all",
  });
  const [userFilters, setUserFilters] = useState({
    role: "all",
    status: "all",
    branch: "all",
  });
  const [companyFilters, setCompanyFilters] = useState({
    state: "all",
    country: "all",
    companySize: "all",
    planType: "all",
    type: "all",
  });

  const filterRef = useRef(null);
  const filterButtonRef = useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

  // Pagination state for plans (similar to CaseList)
  // const [currentPage, setCurrentPage] = useState(0);
  // const [plansPerPage, setPlansPerPage] = useState(20);
  // const [totalPlans, setTotalPlans] = useState(0);
  // const [totalPages, setTotalPages] = useState(0);

  // ADD these instead:
  const [plansPagination, setPlansPagination] = useState({
    page: 0,
    limit: 20,
    total: 0,
    hasMore: false
  });

  const [usersPagination, setUsersPagination] = useState({
    page: 0,
    limit: 10000,
    total: 0,
    hasMore: false
  });

  const [companiesPagination, setCompaniesPagination] = useState({
    page: 0,
    limit: 20,
    total: 0,
    hasMore: false
  });

  // Store all available filter options (fetched once)
  const [availableFilterOptions, setAvailableFilterOptions] = useState({
    planTypes: [],
    userRoles: [],
    states: [],
    countries: [],
    planTypesForCompanies: []
  });

  const location = useLocation();
  const [isInitialLoad, setIsInitialLoad] = useState(true);


  const getInitialActiveTab = () => {
    const currentPath = location.pathname;
    const navigationState = location.state;

    // Check if we're coming from a specific form based on navigation state
    if (navigationState?.fromTab) {
      return navigationState.fromTab;
    }

    // Check current path patterns for user-related routes
    if (
      currentPath.includes("/superadmin/adduser") ||
      currentPath.includes("/superadmin/edituser") ||
      currentPath.includes("/addusers/")
    ) {
      return "users";
    }

    // Check current path patterns for company-related routes
    if (
      currentPath.includes("/superadmin/addcompany") ||
      currentPath.includes("/superadmin/editcompany") ||
      currentPath.includes("/superadmin/companydetails") ||
      currentPath.includes("/superadmin/court-details")
    ) {
      return "companies";
    }

    // Check current path patterns for plan-related routes
    if (
      currentPath.includes("/superadmin/addplan") ||
      currentPath.includes("/superadmin/editplan") ||
      currentPath.includes("/superadmin/plandetails")
    ) {
      return "plans";
    }

    // Check localStorage for last active tab
    const savedTab = localStorage.getItem("superadmin_active_tab");
    if (savedTab && ["plans", "users", "companies"].includes(savedTab)) {
      return savedTab;
    }

    // Default to plans
    return "plans";
  };
  const [activeTab, setActiveTab] = useState(getInitialActiveTab);

  const checkScrapingStatus = async (companiesData = companies) => {
    try {
      // Check High Court scraping status (single API call for all companies)
      const hcResponse = await getHcScrapingStatus();
      const hcStatusData = hcResponse.data;

      const currentlyProcessingHC = new Set();
      hcStatusData.forEach((company) => {
        if (company.processing) {
          currentlyProcessingHC.add(company.companyId);
        }
      });

      setProcessingCompanies(currentlyProcessingHC);

      // Check District Court scraping status (single API call)
      const currentlyProcessingDC = new Set();

      try {
        // Make a single API call for DC status instead of multiple calls
        const dcResponse = await getDcScrapingStatus();
        const dcStatusData = dcResponse.data;

        // If dcStatusData is an array (like HC), iterate through it
        if (Array.isArray(dcStatusData)) {
          dcStatusData.forEach((company) => {
            if (company.processing) {
              currentlyProcessingDC.add(company.companyId);
            }
          });
        } else if (dcStatusData && dcStatusData.processing) {
          // If dcStatusData is a single object with companyId
          if (dcStatusData.companyId) {
            currentlyProcessingDC.add(dcStatusData.companyId);
          }
        }

        setProcessingDistrictCourtCompanies(currentlyProcessingDC);
      } catch (dcError) {
        console.warn("Error checking DC status:", dcError);
        // Set empty set if there's an error
        setProcessingDistrictCourtCompanies(new Set());
      }
    } catch (error) {
      console.error("Error checking scraping status:", error);
    }
  };

  // Fetch all available filter options once (without any filters applied)
  const fetchFilterOptions = useCallback(async () => {
    try {
      // Fetch all plans without any filters to get available options
      const allPlansResponse = await getAllExistPlans('');
      const allPlans = allPlansResponse?.data?.result || allPlansResponse?.data?.plans || allPlansResponse?.data || [];

      // Fetch all users to get available roles
      const allUsersResponse = await getAllUsersForSuperAdmin();
      const allUsers = allUsersResponse?.data?.result || [];

      // Fetch all companies to get available states and countries
      const allCompaniesResponse = await getAllCompaniesForSuperAdmin();
      const allCompanies = allCompaniesResponse?.data?.result || [];

      // Extract unique values for each filter type
      const planTypes = [...new Set(allPlans.map(plan => plan.type).filter(Boolean))].sort();
      const userRoles = [...new Set(allUsers.map(user => user.role).filter(Boolean))].sort();
      const states = [...new Set(allCompanies.map(company => company.state).filter(Boolean))].sort();
      const countries = [...new Set(allCompanies.map(company => company.country).filter(Boolean))].sort();
      const planTypesForCompanies = [...new Set(allCompanies.map(company =>
        company.subscription?.planType || company.planType
      ).filter(Boolean))].sort();

      setAvailableFilterOptions({
        planTypes,
        userRoles,
        states,
        countries,
        planTypesForCompanies
      });
    } catch (error) {
      console.error("Error fetching filter options:", error);
    }
  }, []);

  // Updated initial data loading useEffect
  useEffect(() => {
    const loadInitialData = async () => {
      showLoading("Loading Super Admin Dashboard...");
      try {
        // Load all data in parallel
        const [plansResponse, usersResponse, companiesResponse] =
          await Promise.all([
            getAllExistPlans().catch((error) => {
              console.error("Error fetching plans:", error);
              return { data: { result: [] } };
            }),
            getAllUsersForSuperAdmin().catch((error) => {
              console.error("Error fetching users:", error);
              return { data: { result: [] } };
            }),
            getAllCompaniesForSuperAdmin().catch((error) => {
              console.error("Error fetching companies:", error);
              return { data: { result: [] } };
            }),
          ]);

        // Set plans data
        const plansData =
          plansResponse?.data?.result ||
          plansResponse?.data?.plans ||
          plansResponse?.data ||
          [];
        setPlans(plansData);

        // Set users data
        const usersData = usersResponse?.data?.result || [];
        setUsers(usersData);

        // Set companies data
        const companiesData = companiesResponse?.data?.result || [];
        setCompanies(companiesData);

        // Store companies list for dropdown in user form
        const companiesForDropdown = companiesData.map((company) => ({
          _id: company._id,
          companyName: company.companyName,
        }));
        localStorage.setItem(
          "companiesList",
          JSON.stringify(companiesForDropdown)
        );

        // Now check scraping status for all companies
        await checkScrapingStatus(companiesData);

        setDataLoaded(true);
      } catch (error) {
        console.error("Error loading initial data:", error);
        setDataLoaded(true); // Still set to true to show the page even if there's an error
      } finally {
        hideLoading();
      }
    };

    loadInitialData();
  }, []);

  // Updated status checking useEffect
  useEffect(() => {
    if (!dataLoaded) return; // Don't start interval until initial data is loaded

    const interval = setInterval(() => {
      checkScrapingStatus();
    }, 30000);

    return () => clearInterval(interval);
  }, [companies, dataLoaded]); // Add dataLoaded dependency

  useEffect(() => {
    localStorage.setItem("superadmin_active_tab", activeTab);
  }, [activeTab]);

  const handleDistrictCourtSync = (companyId) => {
    setSelectedCompanyId(companyId);
    setIsDistrictCourtModalOpen(true);
  };

  const handleDistrictCourtSyncConfirm = async () => {
    if (!selectedCompanyId) {
      setIsDistrictCourtModalOpen(false);
      setSelectedCompanyId(null);
      return;
    }

    // Close modal immediately after user confirms
    setIsDistrictCourtModalOpen(false);

    try {
      setSyncingDistrictCourtCompanies((prev) =>
        new Set(prev).add(selectedCompanyId)
      );
      await dcScrapingSync(selectedCompanyId);
      setProcessingDistrictCourtCompanies((prev) =>
        new Set(prev).add(selectedCompanyId)
      );

      // Show success message (optional)
    } catch (error) {
      console.error("Error syncing district court data:", error);

      // Optional: Show error toast/notification here
      // showToast('Failed to start District Court sync', 'error');
    } finally {
      // Clean up syncing state and selected company
      setSyncingDistrictCourtCompanies((prev) => {
        const newSet = new Set(prev);
        newSet.delete(selectedCompanyId);
        return newSet;
      });
      setSelectedCompanyId(null);
    }
  };

  const handleDistrictCourtSyncCancel = () => {
    setIsDistrictCourtModalOpen(false);
    setSelectedCompanyId(null);
  };

  const requiresAction = (company) => {
    // Check if uniqueNames array is empty or undefined
    const hasEmptyUniqueNames =
      !company.uniqueNames ||
      !Array.isArray(company.uniqueNames) ||
      company.uniqueNames.length === 0;


    // Check if highCourt array is empty or undefined
    const hasEmptyHighCourt =
      !company.highCourt ||
      !Array.isArray(company.highCourt) ||
      company.highCourt.length === 0;

    const result = hasEmptyUniqueNames || hasEmptyHighCourt;

    return result;
  };

  const handleSearchToggle = () => {
    if (!showSearchInput) {
      // Open search
      setShowSearchInput(true);
      // Animate search input expansion
      gsap.fromTo(
        sasearchContainerRef.current,
        {
          width: 0,
          opacity: 0,
          overflow: "hidden",
        },
        {
          width: "200px",
          opacity: 1,
          duration: 0.3,
          ease: "power2.out",
          onComplete: () => {
            if (sasearchInputRef.current) {
              sasearchInputRef.current.focus();
            }
          },
        }
      );
    } else {
      // Close search and clear
      handleClearSearch();
    }
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    // Note: We don't trigger fetchPlans here to avoid circular dependency
    // The search input will be cleared and next search will start fresh

    // Animate search input collapse
    gsap.to(sasearchContainerRef.current, {
      width: 0,
      opacity: 0,
      duration: 0.3,
      ease: "power2.in",
      onComplete: () => {
        setShowSearchInput(false);
      },
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Escape") {
      handleClearSearch();
    }
  };

  useEffect(() => {
    if (showSearchInput) {
      handleClearSearch();
    }
  }, [activeTab]);

  // Unified function to fetch plans with all filters and search
  const fetchPlansWithFilters = useCallback(async () => {
    if (activeTab !== "plans") return;

    const params = new URLSearchParams();

    // Add search parameter
    if (sasearchQuery && sasearchQuery.trim()) {
      params.set("search", sasearchQuery.trim());
    }

    // Add filter parameters
    if (planFilters.type && planFilters.type !== "all") {
      params.set("type", planFilters.type);
    }

    if (planFilters.priceRange && planFilters.priceRange !== "all") {
      switch (planFilters.priceRange) {
        case "low":
          params.set("priceRange", "1k-5k");
          break;
        case "medium":
          params.set("priceRange", "5k-15k");
          break;
        case "high":
          params.set("priceRange", "15k%2B");
          break;
        default:
          break;
      }
    }

    if (planFilters.duration && planFilters.duration !== "all") {
      switch (planFilters.duration) {
        case "short":
          params.set("durationRange", "upto-30days");
          break;
        case "medium":
          params.set("durationRange", "30-60days");
          break;
        case "long":
          params.set("durationRange", "60days%2B");
          break;
        default:
          break;
      }
    }

    if (planFilters.casesLimit && planFilters.casesLimit !== "all") {
      switch (planFilters.casesLimit) {
        case "small":
          params.set("caseLimit", "1-50");
          break;
        case "medium":
          params.set("caseLimit", "51-150");
          break;
        case "large":
          params.set("caseLimit", "150%2B");
          break;
        default:
          break;
      }
    }

    if (planFilters.usersLimit && planFilters.usersLimit !== "all") {
      switch (planFilters.usersLimit) {
        case "single":
          params.set("userLimit", "1-10");
          break;
        case "small":
          params.set("userLimit", "10-50");
          break;
        case "large":
          params.set("userLimit", "50%2B");
          break;
        default:
          break;
      }
    }
    params.set("page", plansPagination.page.toString());
    params.set("limit", plansPagination.limit.toString());

    const queryString = params.toString();

    try {
      const response = await getAllExistPlans(queryString ? `?${queryString}` : '');
      const plansData =
        response?.data?.result ||
        response?.data?.plans ||
        response?.data?.data ||
        response?.data ||
        [];
      setPlans(plansData);
      setFilteredPlans(plansData);

    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  }, [sasearchQuery, planFilters, activeTab, plansPagination.page, plansPagination.limit]);

  // Unified function to fetch users with all filters and search
  const fetchUsersWithFilters = useCallback(async () => {
    if (activeTab !== "users") return;

    const params = new URLSearchParams();
    params.set("page", usersPagination.page.toString());
    params.set("limit", usersPagination.limit.toString());

    // Add search parameter
    if (sasearchQuery && sasearchQuery.trim()) {
      params.set("search", sasearchQuery.trim());
    }

    // Add filter parameters
    if (userFilters.status && userFilters.status !== "all") {
      params.set("status", userFilters.status === "inactive" ? "inActive" : "active");
    }

    if (userFilters.branch && userFilters.branch !== "all") {
      if (userFilters.branch === "has_branch") {
        params.set("hasBranch", "true");
      } else if (userFilters.branch === "no_branch") {
        params.set("hasBranch", "false");
      }
    }

    if (userFilters.role && userFilters.role !== "all") {
      params.set("role", userFilters.role);
    }

    const queryString = params.toString();

    try {
      const response = await getAllUsersForSuperAdmin(queryString ? `?${queryString}` : '');
      const usersData = response?.data?.result || response?.data || [];
      setUsers(usersData);
      setFilteredUsers(usersData);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  }, [sasearchQuery, userFilters, activeTab,]);

  // Unified function to fetch companies with all filters and search
  const fetchCompaniesWithFilters = useCallback(async () => {
    if (activeTab !== "companies") return;

    const params = new URLSearchParams();
    params.set("page", companiesPagination.page.toString());
    params.set("limit", companiesPagination.limit.toString());

    // Add search parameter
    if (sasearchQuery && sasearchQuery.trim()) {
      params.set("search", sasearchQuery.trim());
    }

    // Add filter parameters
    if (companyFilters.state && companyFilters.state !== "all") {
      params.set("state", companyFilters.state);
    }

    if (companyFilters.country && companyFilters.country !== "all") {
      params.set("country", companyFilters.country);
    }

    if (companyFilters.companySize && companyFilters.companySize !== "all") {
      params.set("companySize", companyFilters.companySize);
    }

    if (companyFilters.type && companyFilters.type !== "all") {
      params.set("type", companyFilters.type);
    }

    const queryString = params.toString();

    try {
      const response = await getAllCompaniesForSuperAdmin(queryString ? `?${queryString}` : '');
      const companiesData = response?.data?.result || response?.data || [];
      setCompanies(companiesData);
      setFilteredCompanies(companiesData);
      setCompaniesPagination(prev => ({
        ...prev,
        total: response.data?.totalCount || 0, // Use totalCount from your API
        hasMore: response.data?.totalCount > (response.data?.page + 1) * response.data?.limit
      }));


    } catch (error) {
      console.error("Error fetching companies:", error);
      setCompaniesPagination(prev => ({ ...prev, total: 0, hasMore: false }));

    }
  }, [sasearchQuery, companyFilters, activeTab, companiesPagination.page, companiesPagination.limit]);

  // Debounced search and filter effect for plans
  useEffect(() => {
    if (activeTab !== "plans") return;

    const timeoutId = setTimeout(() => {
      fetchPlansWithFilters();
    }, 300); // 300ms debounce

    return () => clearTimeout(timeoutId);
  }, [fetchPlansWithFilters]);

  // Debounced search and filter effect for users
  useEffect(() => {
    if (activeTab !== "users") return;

    const timeoutId = setTimeout(() => {
      fetchUsersWithFilters();
    }, 300); // 300ms debounce

    return () => clearTimeout(timeoutId);
  }, [fetchUsersWithFilters]);

  // Debounced search and filter effect for companies
  useEffect(() => {
    if (activeTab !== "companies") return;

    const timeoutId = setTimeout(() => {
      fetchCompaniesWithFilters();
    }, 300); // 300ms debounce

    return () => clearTimeout(timeoutId);
  }, [fetchCompaniesWithFilters, companiesPagination.page, companiesPagination.limit]);

  const applyCompanyFilters = useCallback(() => {
    let filtered = [...companies];

    if (companyFilters.state !== "all") {
      filtered = filtered.filter(
        (company) =>
          company.state?.toLowerCase() === companyFilters.state.toLowerCase()
      );
    }

    if (companyFilters.country !== "all") {
      filtered = filtered.filter(
        (company) =>
          company.country?.toLowerCase() ===
          companyFilters.country.toLowerCase()
      );
    }

    if (companyFilters.companySize !== "all") {
      filtered = filtered.filter((company) => {
        const userCount = company.users?.length || 0;
        switch (companyFilters.companySize) {
          case "0-10":
            return userCount >= 0 && userCount <= 10;
          case "10-50":
            return userCount >= 10 && userCount <= 50;
          case "50%2B":
            return userCount > 50;
          default:
            return true;
        }
      });
    }

    // Filter by plan type
    if (companyFilters.planType !== "all") {
      filtered = filtered.filter((company) => {
        const planType = company.subscription?.planType || company.planType;
        return (
          planType?.toLowerCase() === companyFilters.planType.toLowerCase()
        );
      });
    }

    // Filter by type
    if (companyFilters.type !== "all") {
      filtered = filtered.filter((company) => {
        return (
          company.type?.toLowerCase() === companyFilters.type.toLowerCase()
        );
      });
    }

    setFilteredCompanies(filtered);
  }, [companies, companyFilters]);

  // Filter useEffect - trigger filters when data or filter values change
  useEffect(() => {
    if (activeTab === "companies") {
      applyCompanyFilters();
    }
    // Plans and Users filtering are handled by their respective unified fetch functions
  }, [
    activeTab,
    companies,
    companyFilters,
    applyCompanyFilters,
  ]);

  // Only trigger fetchPlans when switching to plans tab initially
  // useEffect(() => {
  //   if (activeTab === "plans" && dataLoaded) {
  //     showLoading("Loading Plans...");
  //     // Fetch available filter options first
  //     fetchFilterOptions();

  //     // Use the unified function to fetch plans
  //     fetchPlansWithFilters();
  //     hideLoading();
  //   }
  // }, [activeTab, dataLoaded, fetchFilterOptions, fetchPlansWithFilters]);
  // Only trigger fetchPlans when switching to plans tab initially
    useEffect(() => {

    if (isInitialLoad) {
      return;
    }

    const loadTabData = async () => {
      if (activeTab === "plans") {
        showLoading("Loading Plans...");
        try {
          await fetchFilterOptions();
          await fetchPlansWithFilters();
        } finally {
          hideLoading();
        }
      } else if (activeTab === "users") {
        showLoading("Loading Users...");
        try {
          await fetchFilterOptions();
          await fetchUsersWithFilters();
        } finally {
          hideLoading();
        }
      } else if (activeTab === "companies") {
        showLoading("Loading Companies...");
        try {
          await fetchFilterOptions();
          await fetchCompaniesWithFilters();
        } finally {
          hideLoading();
        }
      }
    };

    // Run the function to load data for the newly active tab.
    loadTabData();
  }, [activeTab]);

  // Only trigger fetchUsers when switching to users tab initially
  // useEffect(() => {
  //   if (activeTab === "users" && dataLoaded) {
  //     showLoading("Loading Users...");
  //     // Fetch available filter options first
  //     fetchFilterOptions();

  //     // Use the unified function to fetch users
  //     fetchUsersWithFilters();
  //     hideLoading();
  //   }
  // }, [activeTab, dataLoaded, fetchFilterOptions, fetchUsersWithFilters]);

  // // Only trigger fetchCompanies when switching to companies tab initially
  // useEffect(() => {
  //   if (activeTab === "companies" && dataLoaded) {
  //     showLoading("Loading Companies...");
  //     // Fetch available filter options first
  //     fetchFilterOptions();

  //     // Use the unified function to fetch companies
  //     fetchCompaniesWithFilters();
  //     hideLoading();
  //   }
  // }, [activeTab, dataLoaded, fetchFilterOptions, fetchCompaniesWithFilters]);

  // Click outside to close filter dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside filter dropdown AND not on the filter icon
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        // Check if the clicked element is the filter icon or its children
        const filterIcon = event.target.closest('.icon-btn[title="Filter"]');
        if (!filterIcon) {
          setShowFilterDropdown(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Position filter dropdown dynamically
  useEffect(() => {
    if (showFilterDropdown && filterButtonRef.current) {
      const buttonRect = filterButtonRef.current.getBoundingClientRect();
      const dropdownWidth = 365;
      const dropdownMargin = 4;
      let leftPosition = buttonRect.left;

      if (leftPosition + dropdownWidth > window.innerWidth) {
        leftPosition = buttonRect.right - dropdownWidth;
      }
      if (leftPosition < 0) {
        leftPosition = 10;
      }

      // Always show below the button, but limit maxHeight if needed
      const availableBelow =
        window.innerHeight - buttonRect.bottom - dropdownMargin;
      setDropdownPosition({
        top: buttonRect.bottom + dropdownMargin,
        left: leftPosition,
        maxHeight: availableBelow > 200 ? Math.min(availableBelow, 500) : 200, // fallback min height
      });
    }

    const handleScroll = (e) => {
      if (!showFilterDropdown) return;
      // Only close if scroll is outside the dropdown
      const dropdown = document.querySelector(".filter-dropdown");
      if (dropdown && e && e.target && dropdown.contains(e.target)) {
        // Scrolling inside the dropdown, do nothing
        return;
      }
      setShowFilterDropdown(false);
    };

    if (showFilterDropdown) {
      window.addEventListener("scroll", handleScroll, true);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [showFilterDropdown]);

  const handleFilterChange = (filterType, value) => {
    if (activeTab === "plans") {
      setPlanFilters((prev) => ({
        ...prev,
        [filterType]: value,
      }));
      // The unified fetchPlansWithFilters will be called automatically via useEffect
    } else if (activeTab === "users") {
      setUserFilters((prev) => ({
        ...prev,
        [filterType]: value,
      }));
    } else if (activeTab === "companies") {
      setCompanyFilters((prev) => ({
        ...prev,
        [filterType]: value,
      }));
    }
  };

  const clearAllFilters = () => {
    if (activeTab === "plans") {
      setPlanFilters({
        type: "all",
        priceRange: "all",
        duration: "all",
        casesLimit: "all",
        usersLimit: "all",
      });
      // The unified fetchPlansWithFilters will be called automatically via useEffect
    } else if (activeTab === "users") {
      setUserFilters({
        role: "all",
        status: "all",
        branch: "all",
      });
    } else if (activeTab === "companies") {
      setCompanyFilters({
        state: "all",
        country: "all",
        companySize: "all",
        planType: "all",
        type: "all",
      });
    }
  };

  const hasActiveFilters = () => {
    if (activeTab === "plans") {
      return Object.values(planFilters).some((filter) => filter !== "all");
    } else if (activeTab === "users") {
      return Object.values(userFilters).some((filter) => filter !== "all");
    } else if (activeTab === "companies") {
      return Object.values(companyFilters).some((filter) => filter !== "all");
    }
    return false;
  };

  const toggleCardExpansion = (cardId, cardType) => {
    const isExpanded = expandedCards.has(cardId);
    const expandableContent = expandableRefs.current[`${cardType}_${cardId}`];
    const arrow = expandableRefs.current[`arrow_${cardType}_${cardId}`];

    if (!expandableContent) return;

    if (isExpanded) {
      // Collapse
      gsap.to(expandableContent, {
        height: 0,
        opacity: 0,
        duration: 0.4,
        ease: "power2.inOut",
        onComplete: () => {
          expandableContent.style.overflow = "hidden";
        },
      });
      gsap.to(arrow, {
        rotation: 0,
        duration: 0.3,
        ease: "power2.inOut",
      });
      setExpandedCards((prev) => {
        const newSet = new Set(prev);
        newSet.delete(cardId);
        return newSet;
      });
    } else {
      // Expand
      expandableContent.style.overflow = "visible";
      const fullHeight = expandableContent.scrollHeight;
      gsap.fromTo(
        expandableContent,
        { height: 0, opacity: 0 },
        {
          height: fullHeight,
          opacity: 1,
          duration: 0.4,
          ease: "power2.inOut",
        }
      );
      gsap.to(arrow, {
        rotation: 180,
        duration: 0.3,
        ease: "power2.inOut",
      });
      setExpandedCards((prev) => new Set(prev).add(cardId));
    }
  };

  const handleCheckStatus = async (companyId) => {
    try {
      const response = await getHcScrapingStatus();
      const statusData = response.data;
      const companyStatus = statusData.find(
        (company) => company.companyId === companyId
      );

      if (companyStatus) {
        if (companyStatus.processing) {
          setShowStatusTooltip(companyId);
          setTimeout(() => setShowStatusTooltip(null), 3000);
        } else {
          setProcessingCompanies((prev) => {
            const newSet = new Set(prev);
            newSet.delete(companyId);
            return newSet;
          });
        }
      }
    } catch (error) {
      console.error("Error checking individual company status:", error);
    }
  };


  const handleCompaniesPageChange = useCallback((newPage) => {
    setCompaniesPagination(prev => ({ ...prev, page: newPage }));
  }, []);

  // const handleCompaniesLimitChange = useCallback((newLimit) => {
  //   setCompaniesPagination(prev => ({ ...prev, limit: newLimit, page: 0 }));
  // }, []);


  const handleCompaniesLimitChange = useCallback((e) => {
    const newCompaniesPerPage = Number(e.target.value);
    setCompaniesPagination(prev => ({
      ...prev,
      limit: newCompaniesPerPage,
      page: 0
    }));
  }, []);

  // // Handle table scroll for scroll indicators
  const handleTableScroll = useCallback(() => {
    if (!tableContainerRef.current || !leftScrollIndicatorRef.current || !rightScrollIndicatorRef.current) return;

    const container = tableContainerRef.current;
    const wrapper = container.closest('.table-wrapper');
    const scrollLeft = container.scrollLeft;
    const scrollWidth = container.scrollWidth;
    const clientWidth = container.clientWidth;
    const maxScrollLeft = scrollWidth - clientWidth;

    // Sync with top scrollbar
    if (topScrollbarRef.current) {
      topScrollbarRef.current.scrollLeft = scrollLeft;
    }

    // Show/hide left scroll indicator
    if (scrollLeft > 10) {
      leftScrollIndicatorRef.current.style.opacity = '1';
      wrapper?.classList.add('show-left-fade');
    } else {
      leftScrollIndicatorRef.current.style.opacity = '0';
      wrapper?.classList.remove('show-left-fade');
    }

    // Show/hide right scroll indicator
    if (scrollLeft < maxScrollLeft - 10) {
      rightScrollIndicatorRef.current.style.opacity = '1';
      wrapper?.classList.add('show-right-fade');
    } else {
      rightScrollIndicatorRef.current.style.opacity = '0';
      wrapper?.classList.remove('show-right-fade');
    }
  }, []);

  // Handle top scrollbar scroll - sync with main table
  const handleTopScrollbarScroll = useCallback(() => {
    if (!topScrollbarRef.current || !tableContainerRef.current) return;
    
    const topScrollLeft = topScrollbarRef.current.scrollLeft;
    tableContainerRef.current.scrollLeft = topScrollLeft;
  }, []);

  // Update top scrollbar width to match table width
  const updateTopScrollbarWidth = useCallback(() => {
    if (!tableContainerRef.current || !topScrollbarContentRef.current) return;
    
    const tableScrollWidth = tableContainerRef.current.scrollWidth;
    topScrollbarContentRef.current.style.width = `${tableScrollWidth}px`;
  }, []);

  // Check scroll indicators on mount and window resize
  useEffect(() => {
    const checkScrollIndicators = () => {
      if (!tableContainerRef.current || !rightScrollIndicatorRef.current) return;

      const container = tableContainerRef.current;
      const wrapper = container.closest('.table-wrapper');
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;
      const isScrollable = scrollWidth > clientWidth;

      // Update scroll indicator state for companies table
      if (activeTab === "companies") {
        setIsCompaniesTableScrollable(isScrollable);
      }

      // Show right indicator and fade if content is scrollable
      if (isScrollable) {
        rightScrollIndicatorRef.current.style.opacity = '1';
        wrapper?.classList.add('show-right-fade');
      } else {
        rightScrollIndicatorRef.current.style.opacity = '0';
        wrapper?.classList.remove('show-right-fade');
      }

      // Hide left indicator and fade initially
      if (leftScrollIndicatorRef.current) {
        leftScrollIndicatorRef.current.style.opacity = '0';
        wrapper?.classList.remove('show-left-fade');
      }
    };

    // Check indicators when companies data changes
    if (companies.length > 0) {
      setTimeout(() => {
        checkScrollIndicators();
        updateTopScrollbarWidth();
      }, 100);
    }

    // Add resize listener
    const handleResize = () => {
      checkScrollIndicators();
      updateTopScrollbarWidth();
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [companies, activeTab, updateTopScrollbarWidth]);


  useEffect(() => {
    if (activeTab === "companies") {
      setCompaniesPagination(prev => ({ ...prev, page: 0 }));
    }
  }, [companyFilters, sasearchQuery, activeTab]);


  const handleHighCourtSync = (companyId) => {
    setSelectedCompanyId(companyId);
    setIsModalOpen(true);
  };

  const handleSyncConfirm = async () => {
    if (!selectedCompanyId) {
      setIsModalOpen(false);
      setSelectedCompanyId(null);
      return;
    }

    // Close modal immediately after user confirms
    setIsModalOpen(false);

    try {
      setSyncingCompanies((prev) => new Set(prev).add(selectedCompanyId));
      await hcScrapingSync(selectedCompanyId);
      setProcessingCompanies((prev) => new Set(prev).add(selectedCompanyId));

      // Show success message (optional)
    } catch (error) {
      console.error("Error syncing high court data:", error);

      // Optional: Show error toast/notification here
      // showToast('Failed to start High Court sync', 'error');
    } finally {
      // Clean up syncing state and selected company
      setSyncingCompanies((prev) => {
        const newSet = new Set(prev);
        newSet.delete(selectedCompanyId);
        return newSet;
      });
      setSelectedCompanyId(null);
    }
  };

  const handleSyncCancel = () => {
    setIsModalOpen(false);
    setSelectedCompanyId(null);
  };

  const handleAddClick = (type) => {
    navigate(`/home/superadmin/add${type}`, {
      state: { fromTab: activeTab },
    });
  };

  const handleEditClick = (type, id) => {
    navigate(`/home/superadmin/edit${type}/${id}`, {
      state: { fromTab: activeTab },
    });
  };

  const handleDeleteClick = (type, id) => {
    setDeleteModal({ isOpen: true, type, id });
  };

  const handleDeleteConfirm = async () => {
    const { type, id } = deleteModal;
    try {
      switch (type) {
        case "plan":
          await deletePlan(id);
          setPlans((prev) => prev.filter((plan) => plan._id !== id));
          break;
        case "user":
          await deleteUserBySuperAdmin(id);
          const usersResponse = await getAllUsersForSuperAdmin();
          setUsers(usersResponse?.data.result || []);
          break;
        case "company":
          await deleteCompany(id);
          const companiesResponse = await getAllCompaniesForSuperAdmin();
          const companiesData = companiesResponse?.data.result || [];
          setCompanies(companiesData);
          // Update companies list for dropdown
          const companiesForDropdown = companiesData.map((company) => ({
            _id: company._id,
            companyName: company.companyName,
          }));
          localStorage.setItem(
            "companiesList",
            JSON.stringify(companiesForDropdown)
          );
          break;
        default:
          break;
      }
      // Show success message
    } catch (error) {
      console.error(`Error deleting ${type}:`, error);
      // Show error message
    } finally {
      setDeleteModal({ isOpen: false, type: "", id: null });
    }
  };

  const handleDeleteCancel = () => {
    setDeleteModal({ isOpen: false, type: "", id: null });
  };

  // Status modal handlers
  const handleStatusToggle = (companyId, currentStatus) => {
    setStatusModal({
      isOpen: true,
      companyId,
      currentStatus,
    });
  };

  const handleStatusConfirm = async () => {
    try {
      const { companyId, currentStatus } = statusModal;
      const newStatus = !currentStatus;

      // Call API to update company status
      await updateCompanyBySuperAdmin(companyId, { isActive: newStatus });

      // Update the local state only after successful API call
      // setCompanies(prev =>
      //     prev.map(company =>
      //         company._id === companyId
      //             ? { ...company, isActive: newStatus }
      //             : company
      //     )
      // );
      const companiesResponse = await getAllCompaniesForSuperAdmin();
      const companiesData = companiesResponse?.data.result || [];
      setCompanies(companiesData);
      window.location.reload();

    } catch (error) {
      console.error("Error updating company status:", error);
    } finally {
      setStatusModal({ isOpen: false, companyId: null, currentStatus: false });
    }
  };

  const handleStatusCancel = () => {
    setStatusModal({ isOpen: false, companyId: null, currentStatus: false });
  };

  // User status modal handlers
  const handleUserStatusToggle = (userId, currentStatus) => {
    setUserStatusModal({
      isOpen: true,
      userId,
      currentStatus,
    });
  };

  const handleUserStatusConfirm = async () => {
    try {
      const { userId, currentStatus } = userStatusModal;
      const newStatus = !currentStatus;

      // Call API to update user status
      await updateUserBySuperAdmin(userId, { isActive: newStatus });

      // Refresh users list after successful API call
      const usersResponse = await getAllUsersForSuperAdmin();
      const usersData = usersResponse?.data.result || [];
      setUsers(usersData);
      window.location.reload();
    } catch (error) {
      console.error("Error updating user status:", error);
    } finally {
      setUserStatusModal({ isOpen: false, userId: null, currentStatus: false });
    }
  };

  const handleUserStatusCancel = () => {
    setUserStatusModal({ isOpen: false, userId: null, currentStatus: false });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
    });
  };

  // Loading screen component
  const renderLoadingScreen = () => (
    <div className="loading-screen">
      <div className="loading-container">
        <div className="loading-spinner">
          <svg className="spinner" width="50" height="50" viewBox="0 0 24 24">
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
              strokeDasharray="32"
              strokeDashoffset="32"
            >
              <animate
                attributeName="stroke-dashoffset"
                values="32;0;32"
                dur="1.5s"
                repeatCount="indefinite"
              />
            </circle>
          </svg>
        </div>
        <h2>Loading Super Admin Dashboard</h2>
        <p>Fetching data and checking scraping status...</p>
      </div>
    </div>
  );

  const renderTabs = () => (
    <div className="tabs">
      {["plans", "users", "companies"].map((tab) => (
        <button
          key={tab}
          className={activeTab === tab ? "active" : ""}
          onClick={() => setActiveTab(tab)}
        >
          {tab.charAt(0).toUpperCase() + tab.slice(1)}
        </button>
      ))}
    </div>
  );

  const handleManageCases = useCallback(() => {
    setIsCompanySelectionModalOpen(true);
  }, []);

  const handleCompanySelect = useCallback((company) => {
    setSelectedCompanyForManage(company);
    setIsCompanySelectionModalOpen(false);
    setIsCompanyModalOpen(true);
    setPersistedSelectedRefs(new Set());
  }, []);

  const renderHeader = () => {
    const buttonConfig = {
      plans: { text: "Add Plan", type: "plan" },
      users: { text: "Add User", type: "user" },
      companies: { text: "Add Company", type: "company" },
    };

    const config = buttonConfig[activeTab];

    return (
      <div className="invoices-header">
        <div className="left-section">
          <div className="filter-sort-icons">
            <button
              ref={filterButtonRef}
              className={`icon-btn ${hasActiveFilters() ? "active" : ""}`}
              title="Filter"
              onClick={() => setShowFilterDropdown(!showFilterDropdown)}
            >
              <FaFilter />
              {hasActiveFilters() && <span className="filter-indicator"></span>}
            </button>
            {/* <button className="icon-btn" title="Sort">
                                <FaSort />
                            </button> */}
            <div className="sa-search-wrapper">
              <button
                ref={searchButtonRef}
                className={`icon-btn ${showSearchInput ? "active" : ""}`}
                title="Search"
                onClick={handleSearchToggle}
              >
                {showSearchInput ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                ) : (
                  <FaSearch />
                )}
              </button>

              <div
                ref={sasearchContainerRef}
                className="sa-search-input-container"
                style={{
                  width: 0,
                  opacity: 0,
                  overflow: "hidden",
                  marginLeft: "8px",
                }}
              >
                <input
                  ref={sasearchInputRef}
                  type="text"
                  value={sasearchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={handleKeyPress}
                  placeholder={`Search ${activeTab}...`}
                  className="sa-search-input"
                />
                {isSearching && (
                  <div className="sa-search-loading">
                    <svg
                      className="sa-spinner"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeDasharray="32"
                        strokeDashoffset="32"
                      >
                        <animate
                          attributeName="stroke-dashoffset"
                          values="32;0;32"
                          dur="1s"
                          repeatCount="indefinite"
                        />
                      </circle>
                    </svg>
                  </div>
                )}
              </div>
            </div>

            {activeTab === "companies" && (

              <div className="pagination-settings">
                <label htmlFor="saPerPageSelect">Companies per page:</label>
                <select
                  id="saPerPageSelect"
                  value={companiesPagination.limit}
                  onChange={handleCompaniesLimitChange}
                >
                  {[5, 10, 15, 20, 25, 50].map((n) => (
                    <option key={n} value={n}>
                      {n}
                    </option>
                  ))}
                </select>
              </div>


            )}
          </div>
        </div>

        <div className="action-button-container">
          <div className="view-toggle-wrapper">
            <button
              className={`view-toggle-btn ${viewMode === "card" ? "active" : ""
                }`}
              onClick={() => setViewMode("card")}
            >
              <IoGrid />
            </button>
            <button
              className={`view-toggle-btn ${viewMode === "table" ? "active" : ""
                }`}
              onClick={() => setViewMode("table")}
            >
              <FaTableList />
            </button>

          </div>
          {activeTab === "companies" && (
            <>

              <button
                className="manage-cases-btn add-button"
                onClick={handleManageCases}
              >
                Manage Cases
              </button>
            </>
          )}
          <button
            className="add-button"
            onClick={() => handleAddClick(config.type)}
          >
            <span className="add-icon">+</span>
            {config.text}
          </button>
        </div>
      </div>
    );
  };

  const renderFilterDropdown = () => {
    if (!showFilterDropdown || dropdownPosition.top === 0) return null;

    // Get unique values for company filters from the companies data
    const getUniqueUserRoles = () => {
      // Use availableFilterOptions if available, otherwise fall back to current data
      if (availableFilterOptions?.userRoles?.length > 0) {
        return availableFilterOptions.userRoles;
      }
      const roles = users.map((user) => user.role).filter(Boolean);
      return [...new Set(roles)].sort();
    };

    const getUniqueStates = () => {
      // Use availableFilterOptions if available, otherwise fall back to current data
      if (availableFilterOptions?.states?.length > 0) {
        return availableFilterOptions.states;
      }
      const states = companies.map((company) => company.state).filter(Boolean);
      return [...new Set(states)].sort();
    };

    const getUniqueCountries = () => {
      // Use availableFilterOptions if available, otherwise fall back to current data
      if (availableFilterOptions?.countries?.length > 0) {
        return availableFilterOptions.countries;
      }
      const countries = companies
        .map((company) => company.country)
        .filter(Boolean);
      return [...new Set(countries)].sort();
    };

    const getUniqueCompanyTypes = () => {
      // Use availableFilterOptions if available, otherwise fall back to current data
      if (availableFilterOptions?.planTypes?.length > 0) {
        return availableFilterOptions.planTypes;
      }
      const types = plans.map((plan) => plan.type).filter(Boolean);
      return [...new Set(types)].sort();
    };

    // Helper to get unique plan types from all available plans (not filtered)
    const getUniquePlanTypes = () => {
      // Use availableFilterOptions if available, otherwise fall back to current data
      if (availableFilterOptions?.planTypes?.length > 0) {
        return availableFilterOptions.planTypes;
      }
      const types = plans.map((plan) => plan.type).filter(Boolean);
      return [...new Set(types)].sort();
    };

    // Helper to get display name for plan types
    const getPlanTypeDisplayName = (type) => {
      const typeMapping = {
        'std': 'Standard',
        'ent': 'Enterprise',
        'ind': 'Individual',
        'prm': 'Premium'
      };
      return typeMapping[type?.toLowerCase()] || type?.toUpperCase();
    };

    return (
      <div
        className="filter-dropdown"
        ref={filterRef}
        style={{
          top: `${dropdownPosition.top}px`,
          left: `${dropdownPosition.left}px`,
          position: "fixed",
        }}
      >
        <div className="filter-content">
          {activeTab === "plans" && (
            <>
              {/* Plan Type Filter (dynamic) */}
              <div className="filter-group">
                <label>Plan Type</label>
                <select
                  value={planFilters.type}
                  onChange={(e) => handleFilterChange("type", e.target.value)}
                >
                  <option value="all">All Types</option>
                  {getUniquePlanTypes().map((type) => (
                    <option key={type} value={type}>
                      {getPlanTypeDisplayName(type)}
                    </option>
                  ))}
                </select>
              </div>

              {/* Price Range Filter */}
              <div className="filter-group">
                <label>Price Range</label>
                <select
                  value={planFilters.priceRange}
                  onChange={(e) =>
                    handleFilterChange("priceRange", e.target.value)
                  }
                >
                  <option value="all">All Prices</option>
                  <option value="low">1000-5000</option>
                  <option value="medium">₹5,000 - ₹15,000</option>
                  <option value="high">Above ₹15,000</option>
                </select>
              </div>

              {/* Duration Filter */}
              <div className="filter-group">
                <label>Duration</label>
                <select
                  value={planFilters.duration}
                  onChange={(e) =>
                    handleFilterChange("duration", e.target.value)
                  }
                >
                  <option value="all">All Durations</option>
                  <option value="short">Up to 30 days</option>
                  <option value="medium">30 - 60 days</option>
                  <option value="long">Above 60 days</option>
                </select>
              </div>

              {/* Cases Limit Filter */}
              <div className="filter-group">
                <label>Cases Limit</label>
                <select
                  value={planFilters.casesLimit}
                  onChange={(e) =>
                    handleFilterChange("casesLimit", e.target.value)
                  }
                >
                  <option value="all">All Cases</option>
                  <option value="small">Up to 50 cases</option>
                  <option value="medium">51 - 150 cases</option>
                  <option value="large">Above 150 cases</option>
                </select>
              </div>

              {/* Users Limit Filter */}
              <div className="filter-group">
                <label>Users Limit</label>
                <select
                  value={planFilters.usersLimit}
                  onChange={(e) =>
                    handleFilterChange("usersLimit", e.target.value)
                  }
                >
                  <option value="all">All Users</option>
                  <option value="single">1 - 10 Users</option>
                  <option value="small">10 - 50 Users</option>
                  <option value="large">Above 50 Users</option>
                </select>
              </div>
            </>
          )}

          {activeTab === "users" && (
            <>
              {/* Role Filter */}
              <div className="filter-group">
                <label>Role</label>
                <select
                  value={userFilters.role}
                  onChange={(e) => handleFilterChange("role", e.target.value)}
                >
                  <option value="all">All Roles</option>
                  {getUniqueUserRoles().map((role) => (
                    <option key={role} value={role}>
                      {role?.charAt(0).toUpperCase() + role?.slice(1)}
                    </option>
                  ))}
                </select>
              </div>

              {/* Status Filter */}
              <div className="filter-group">
                <label>Status</label>
                <select
                  value={userFilters.status}
                  onChange={(e) => handleFilterChange("status", e.target.value)}
                >
                  <option value="all">All Status</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>

              {/* Branch Filter */}
              <div className="filter-group">
                <label>Branch Assignment</label>
                <select
                  value={userFilters.branch}
                  onChange={(e) => handleFilterChange("branch", e.target.value)}
                >
                  <option value="all">All</option>
                  <option value="has_branch">Has Branch</option>
                  <option value="no_branch">No Branch</option>
                </select>
              </div>
            </>
          )}

          {activeTab === "companies" && (
            <>
              {/* State Filter */}
              <div className="filter-group">
                <label>State</label>
                <select
                  value={companyFilters.state}
                  onChange={(e) => handleFilterChange("state", e.target.value)}
                >
                  <option value="all">All States</option>
                  {getUniqueStates().map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
              </div>

              {/* Country Filter */}
              <div className="filter-group">
                <label>Country</label>
                <select
                  value={companyFilters.country}
                  onChange={(e) =>
                    handleFilterChange("country", e.target.value)
                  }
                >
                  <option value="all">All Countries</option>
                  {getUniqueCountries().map((country) => (
                    <option key={country} value={country}>
                      {country}
                    </option>
                  ))}
                </select>
              </div>

              {/* Company Size Filter */}
              <div className="filter-group">
                <label>Company Size</label>
                <select
                  value={companyFilters.companySize}
                  onChange={(e) =>
                    handleFilterChange("companySize", e.target.value)
                  }
                >
                  <option value="all">All Sizes</option>
                  <option value="0-10">0-10 Users</option>
                  <option value="10-50">10-50 Users</option>
                  <option value="50%2B">50+ Users</option>
                </select>
              </div>

              {/* Type Filter */}
              <div className="filter-group">
                <label>Type</label>
                <select
                  value={companyFilters.type}
                  onChange={(e) =>
                    handleFilterChange("type", e.target.value)
                  }
                >
                  <option value="all">All Types</option>
                  {getUniqueCompanyTypes().map((type) => (
                    <option key={type} value={type}>
                      {getPlanTypeDisplayName(type)}
                    </option>
                  ))}
                </select>
              </div>
            </>
          )}

          <div className="filter-actions">
            <button
              className="clear-filters"
              onClick={clearAllFilters}
              disabled={!hasActiveFilters()}
            >
              Clear All
            </button>
            <button
              className="apply-filters"
              onClick={() => setShowFilterDropdown(false)}
            >
              Hide Filters
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderCardActions = (type, id) => (
    <div className="card-actions">
      {type === "company" && (
        <button
          className="add-edit-courtdetails"
          onClick={() =>
            navigate(`/home/superadmin/court-details/${id}`, {
              state: { fromTab: activeTab },
            })
          }
        >
          <div className="court-tooltip-wrapper">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14,2 14,8 20,8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10,9 9,9 8,9"></polyline>
            </svg>
            <span className="court-tooltip">Add/Edit Court Details</span>
          </div>
        </button>
      )}
      <button className="edit-btn" onClick={() => handleEditClick(type, id)}>
        <div className="court-tooltip-wrapper">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
            <path d="m18.5 2.5-4 4 2 2 4-4a2 2 0 0 0 0-2.83l-.17-.17a2 2 0 0 0-2.83 0z"></path>
          </svg>
          <span className="court-tooltip">Edit</span>
        </div>
      </button>
      <button
        className="delete-btn"
        onClick={() => handleDeleteClick(type, id)}
      >
        <div className="court-tooltip-wrapper">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <polyline points="3,6 5,6 21,6"></polyline>
            <path d="m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"></path>
            <line x1="10" y1="11" x2="10" y2="17"></line>
            <line x1="14" y1="11" x2="14" y2="17"></line>
          </svg>
          <span className="court-tooltip">Delete</span>
        </div>
      </button>
    </div>
  );

  const renderTableActions = (type, id) => (
    <div className="table-actions">
      {type === "company" && (
        <button
          className="court-details-btn"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/home/superadmin/court-details/${id}`, {
              state: { fromTab: activeTab },
            });
          }}
        >
          <div className="court-tooltip-wrapper">
            <FaFileAlt />
            <span className="court-tooltip">Court Details</span>
          </div>
        </button>
      )}
      {/* update and delete action buttons */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          handleEditClick(type, id);
        }}
        className="edit-btn"
      >
        <div className="court-tooltip-wrapper">
          <BiEdit />
          <span className="court-tooltip">Edit</span>
        </div>
      </button>

      <button
        onClick={(e) => {
          e.stopPropagation();
          handleDeleteClick(type, id);
        }}
        className="del-btn"
      >
        <div className="court-tooltip-wrapper">
          <BiTrash />
          <span className="court-tooltip">Delete</span>
        </div>
      </button>
    </div>
  );

  const renderPlansCard = () => {
    if (plans.length === 0) {
      return (
        <div className="no-results">
          <p>No Plans Found.</p>
        </div>
      );
    }
    return (
      <div className="card-container-plans">
        {(activeTab === "plans" ? filteredPlans : plans).map((plan) => {
          const planFields = [
            {
              label: "Price",
              value: `₹${plan.price?.toLocaleString()}`,
              highlight: true,
            },
            { label: "Duration", value: `${plan.duration} days` },
            { label: "Cases", value: plan.casesLimit || plan.caseLimit },
            { label: "Users", value: plan.usersLimit || plan.userLimit },
            { label: "Type", value: plan.type?.toUpperCase(), highlight: true },
          ];

          const visibleFields = planFields.slice(0, 5);
          const planEntries = Object.entries(plan.rights || {});
          const hasRights = planEntries.length > 0;

          return (
            <div
              className="card"
              key={plan._id}
              onClick={() =>
                navigate(`/home/superadmin/plandetails/${plan._id}`)
              }
              style={{ cursor: "pointer" }}
            >
              {renderCardActions("plan", plan._id)}
              <h3>{plan.name}</h3>
              <div className="card-content">
                {visibleFields.map((field, index) => (
                  <div key={index} className="info-item">
                    <span className="label">{field.label}</span>
                    <span
                      className={`value ${field.highlight ? "highlight" : ""}`}
                    >
                      {field.value}
                    </span>
                  </div>
                ))}
              </div>

              {hasRights && (
                <>
                  <div className="accordion-header">
                    <button
                      className="accordion-toggle"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleCardExpansion(plan._id, "plan");
                      }}
                    >
                      <span>Permissions</span>
                      <svg
                        ref={(el) =>
                        (expandableRefs.current[`arrow_plan_${plan._id}`] =
                          el)
                        }
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <polyline points="6,9 12,15 18,9"></polyline>
                      </svg>
                    </button>
                  </div>

                  <div
                    className="expandable-content"
                    ref={(el) =>
                      (expandableRefs.current[`plan_${plan._id}`] = el)
                    }
                  >
                    <div className="rights-container">
                      <div className="rights-grid">
                        {planEntries.map(([key, value]) => (
                          <div
                            key={key}
                            className={`right-item ${value ? "enabled" : "disabled"
                              }`}
                          >
                            {key.replace(/([A-Z])/g, " $1").toLowerCase()}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          );
        })}
        {/* {activeTab === "plans" &&
          filteredPlans.length === 0 &&
          plans.length > 0 && (
            <div className="no-results">
              <p>No plans match the selected filters.</p>
              <button onClick={clearAllFilters} className="clear-filters-btn">
                Clear Filters
              </button>
            </div>
          )} */}
      </div>
    );
  };

  const renderUsersCard = () => {
    if (users.length === 0) {
      return (
        <div className="no-results">
          <p>No Users Found.</p>
        </div>
      );
    }
    return (
      <div className="card-container">
        {(activeTab === "users" ? filteredUsers : users).map((user) => {
          const userFields = [
            { label: "Email", value: user.email },
            { label: "Role", value: user.role?.toUpperCase(), highlight: true },
            {
              label: "Status",
              value: (
                <button
                  className={`status-toggle-btn ${user.isActive ? "active" : "inactive"
                    }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleUserStatusToggle(user._id, user.isActive);
                  }}
                >
                  {user.isActive ? "Active" : "Inactive"}
                </button>
              ),
              badge: false,
            },
            { label: "Created", value: formatDate(user.createdAt) },
            { label: "Branches", value: user.branchIds?.length || 0 },
            { label: "Phone", value: user.phone || "N/A" },
            { label: "Department", value: user.department || "N/A" },
            {
              label: "Last Login",
              value: user.lastLogin ? formatDate(user.lastLogin) : "Never",
            },
          ];

          const visibleFields = userFields.slice(0, 5);
          const hiddenFields = userFields.slice(5);
          const hasMoreItems = hiddenFields.length > 0;

          return (
            <div
              className="card user-card-clickable"
              key={user._id}
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                if (
                  e.target.closest(".card-actions") ||
                  e.target.closest(".accordion-toggle")
                )
                  return;
                navigate(`/home/addusers/${user._id}`, {
                  state: { fromTab: activeTab },
                });
              }}
            >
              {renderCardActions("user", user._id)}
              <h3>{user.name}</h3>
              <div className="card-content">
                {visibleFields.map((field, index) => (
                  <div key={index} className="info-item">
                    <span className="label">{field.label}</span>
                    <span
                      className={`value ${field.highlight ? "highlight" : ""}`}
                    >
                      {field.badge ? (
                        <span
                          className={`status-badge ${user.isActive ? "active" : "inactive"
                            }`}
                        >
                          {field.value}
                        </span>
                      ) : (
                        field.value
                      )}
                    </span>
                  </div>
                ))}
              </div>

              {hasMoreItems && (
                <>
                  <div className="accordion-header">
                    <button
                      className="accordion-toggle"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleCardExpansion(user._id, "user");
                      }}
                    >
                      <span>More Details</span>
                      <svg
                        ref={(el) =>
                        (expandableRefs.current[`arrow_user_${user._id}`] =
                          el)
                        }
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <polyline points="6,9 12,15 18,9"></polyline>
                      </svg>
                    </button>
                  </div>

                  <div
                    className="expandable-content"
                    ref={(el) =>
                      (expandableRefs.current[`user_${user._id}`] = el)
                    }
                  >
                    <div className="card-content">
                      {hiddenFields.map((field, index) => (
                        <div key={index} className="info-item">
                          <span className="label">{field.label}</span>
                          <span
                            className={`value ${field.highlight ? "highlight" : ""
                              }`}
                          >
                            {field.value}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
          );
        })}
        {/* {activeTab === "users" &&
          filteredUsers.length === 0 &&
          users.length > 0 && (
            <div className="no-results">
              <p>
                {sasearchQuery
                  ? `No users found for "${sasearchQuery}"`
                  : "No users match the selected filters."}
              </p>
              {sasearchQuery ? (
                <button
                  onClick={handleClearSearch}
                  className="clear-filters-btn"
                >
                  Clear Search
                </button>
              ) : (
                <button onClick={clearAllFilters} className="clear-filters-btn">
                  Clear Filters
                </button>
              )}
            </div>
          )} */}
      </div>
    );
  };

  const renderUsersTable = () => {
    if (users.length === 0) {
      return (
        <div className="no-results">
          <p>No Users Found.</p>
        </div>
      );
    }
    return (
      <>
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Status</th>
              <th>Created</th>
              <th>Branches</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {(activeTab === "users" ? filteredUsers : users).map((user) => (
              <tr
                key={user._id}
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  if (e.target.closest(".table-actions")) return;
                  navigate(`/home/addusers/${user._id}`, {
                    state: { fromTab: activeTab },
                  });
                }}
              >
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>{user.role?.toUpperCase()}</td>
                <td>
                  <button
                    className={`status-toggle-btn ${user.isActive ? "active" : "inactive"
                      }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleUserStatusToggle(user._id, user.isActive);
                    }}
                  >
                    {user.isActive ? "Active" : "Inactive"}
                  </button>
                </td>
                <td>{formatDate(user.createdAt)}</td>
                <td>{user.branchIds?.length || 0}</td>
                <td>{renderTableActions("user", user._id)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* {activeTab === "users" &&
          filteredUsers.length === 0 &&
          users.length > 0 && (
            <div className="no-results">
              <p>
                {sasearchQuery
                  ? `No users found for "${sasearchQuery}"`
                  : "No users match the selected filters."}
              </p>
              {sasearchQuery ? (
                <button
                  onClick={handleClearSearch}
                  className="clear-filters-btn"
                >
                  Clear Search
                </button>
              ) : (
                <button onClick={clearAllFilters} className="clear-filters-btn">
                  Clear Filters
                </button>
              )}
            </div>
          )} */}
      </>
    );
  };

  const renderCompaniesCard = () => {
    if (companies.length === 0) {
      return (
        <div className="no-results">
          <p>No Companies Found.</p>
        </div>
      );
    }
    return (

      <>
        <div className="card-container-company">
          {(activeTab === "companies" ? filteredCompanies : companies).map(
            (company) => {
              const companyFields = [
                { label: "Email", value: company.email },
                { label: "Phone", value: company.phno },
                {
                  label: "Status",
                  value: (
                    <button
                      className={`status-toggle-btn ${company.isActive ? "active" : "inactive"
                        }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleStatusToggle(company._id, company.isActive);
                      }}
                    >
                      {company.isActive ? "Active" : "Inactive"}
                    </button>
                  ),
                  badge: false,
                },
                { label: "Website", value: company.website, link: true },
                {
                  label: "Location",
                  value: `${company.address}, ${company.state}, ${company.country} - ${company.zip}`,
                },
                { label: "Users", value: company.users?.length || 0 },
                { label: "Branches", value: company.branches?.length || 0 },
                {
                  label: "Scraping",
                  value: company.allowScrape ? "Enabled" : "Disabled",
                  badge: true,
                },
                {
                  label: "Payment",
                  value: company.subscription?.paymenStatus || "N/A",
                  badge: true,
                },
              ];

              const visibleFields = companyFields.slice(0, 7);
              const hiddenFields = companyFields.slice(7);
              const hasMoreItems =
                hiddenFields.length > 0 ||
                Object.keys(company.rights || {}).length > 0;

              return (
                <div
                  className="card"
                  key={company._id}
                  onClick={(e) => {
                    if (
                      e.target.closest(".card-actions") ||
                      e.target.closest(".accordion-toggle")
                    )
                      return;
                    navigate(`/home/superadmin/companydetails/${company._id}`);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {renderCardActions("company", company._id)}

                  {requiresAction(company) && (
                    <span className="action-required-badge card-badge-positioned">
                      Empty Court Details
                    </span>
                  )}
                  <h3>{company.companyName}</h3>
                  <div className="card-content">
                    {visibleFields.map((field, index) => (
                      <div key={index} className="info-item">
                        <span className="label">{field.label}</span>
                        <span
                          className={`value ${field.highlight ? "highlight" : ""
                            }`}
                        >
                          {field.badge ? (
                            <span
                              className={`status-badge ${field.label === "Status"
                                  ? company.isActive
                                    ? "active"
                                    : "inactive"
                                  : field.label === "Scraping"
                                    ? company.allowScrape
                                      ? "active"
                                      : "inactive"
                                    : company.subscription?.paymenStatus ===
                                      "Success"
                                      ? "active"
                                      : "inactive"
                                }`}
                            >
                              {field.value}
                            </span>
                          ) : field.link ? (
                            <a
                              href={field.value}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {field.value}
                            </a>
                          ) : (
                            field.value
                          )}
                        </span>
                      </div>
                    ))}
                  </div>

                  {hasMoreItems && (
                    <>
                      <div className="accordion-header">
                        <button
                          className="accordion-toggle"
                          onClick={() =>
                            toggleCardExpansion(company._id, "company")
                          }
                        >
                          <span>Company Rights & More</span>
                          <svg
                            ref={(el) =>
                            (expandableRefs.current[
                              `arrow_company_${company._id}`
                            ] = el)
                            }
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <polyline points="6,9 12,15 18,9"></polyline>
                          </svg>
                        </button>
                      </div>

                      <div
                        className="expandable-content"
                        ref={(el) =>
                          (expandableRefs.current[`company_${company._id}`] = el)
                        }
                      >
                        {hiddenFields.length > 0 && (
                          <div className="card-content">
                            {hiddenFields.map((field, index) => (
                              <div key={index} className="info-item">
                                <span className="label">{field.label}</span>
                                <span
                                  className={`value ${field.highlight ? "highlight" : ""
                                    }`}
                                >
                                  {field.value}
                                </span>
                              </div>
                            ))}
                          </div>
                        )}

                        {Object.keys(company.rights || {}).length > 0 && (
                          <div className="rights-container">
                            <div className="rights-header">Company Rights</div>
                            <div className="rights-grid">
                              {Object.entries(company.rights || {}).map(
                                ([key, value]) => (
                                  <div
                                    key={key}
                                    className={`right-item ${value ? "enabled" : "disabled"
                                      }`}
                                  >
                                    {key.replace(/([A-Z])/g, " $1").toLowerCase()}
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  {/* Sync Courts Section */}
                  <div className="sync-courts-section">
                    <div className="sync-courts-header">Sync Courts</div>
                    <div className="sync-buttons">
                    <div className="sync-button-wrapper">
                      <button
                        className="sync-btn high-court-sync"
                        onClick={() => handleHighCourtSync(company._id)}
                        disabled={
                          syncingCompanies.has(company._id) ||
                          processingCompanies.has(company._id)
                        }
                        onMouseEnter={() => {
                          if (processingCompanies.has(company._id)) {
                            setShowStatusTooltip(company._id);
                          }
                        }}
                        onMouseLeave={() => setShowStatusTooltip(null)}
                      >
                        {syncingCompanies.has(company._id)
                          ? "Syncing..."
                          : processingCompanies.has(company._id)
                            ? "Processing..."
                            : "High Court"}
                      </button>

                      {/* Status Check Tooltip */}
                      {showStatusTooltip === company._id &&
                        processingCompanies.has(company._id) && (
                          <div className="status-tooltip">
                            <button
                              className="check-status-btn"
                              onClick={() => handleCheckStatus(company._id)}
                            >
                              Check Status
                            </button>
                          </div>
                        )}

                      {/* Processing Status Tooltip */}
                      {showStatusTooltip === company._id &&
                        processingCompanies.has(company._id) && (
                          <div className="processing-tooltip">
                            Scraping is still in progress...
                          </div>
                        )}
                    </div>

                    <button
                      className="sync-btn district-court-sync"
                      onClick={() => handleDistrictCourtSync(company._id)}
                      disabled={
                        syncingDistrictCourtCompanies.has(company._id) ||
                        processingDistrictCourtCompanies.has(company._id)
                      }
                    >
                      {syncingDistrictCourtCompanies.has(company._id)
                        ? "Syncing..."
                        : processingDistrictCourtCompanies.has(company._id)
                          ? "Processing..."
                          : "District Court"}
                    </button>
                  </div>
                  </div>
                </div>
              );
            }
          )}
          {/* {activeTab === "companies" &&
          filteredCompanies.length === 0 &&
          companies.length > 0 && (
            <div className="no-results">
              <p>No companies match the selected filters.</p>
              <button onClick={clearAllFilters} className="clear-filters-btn">
                Clear Filters
              </button>
            </div>
          )} */}
        </div>
        {(companiesPagination.total > companiesPagination.limit || companiesPagination.page > 0) && (
          <div className="pagination-controls">
            <button
              disabled={companiesPagination.page === 0}
              onClick={() => handleCompaniesPageChange(0)}
            >
              First
            </button>
            <button
              disabled={companiesPagination.page === 0}
              onClick={() => handleCompaniesPageChange(companiesPagination.page - 1)}
            >
              Previous
            </button>
            <span>
              Page {companiesPagination.page + 1} of {Math.ceil(companiesPagination.total / companiesPagination.limit)}
            </span>
            <button
              disabled={companiesPagination.page >= Math.ceil(companiesPagination.total / companiesPagination.limit) - 1}
              onClick={() => handleCompaniesPageChange(companiesPagination.page + 1)}
            >
              Next
            </button>
            <button
              disabled={companiesPagination.page >= Math.ceil(companiesPagination.total / companiesPagination.limit) - 1}
              onClick={() => handleCompaniesPageChange(Math.ceil(companiesPagination.total / companiesPagination.limit) - 1)}
            >
              Last
            </button>
          </div>
        )}
      </>
    );
  };

  const renderCompaniesTable = () => {
    if (companies.length === 0) {
      return (
        <div className="no-results">
          <p>No Companies Found.</p>
        </div>
      );
    }
    return (
      <>
        {isCompaniesTableScrollable && (
          <div className="horizontal-scroll-badge">
            <span className="action-required-badge table-badge">
              Scroll Horizontally
            </span>
          </div>
        )}
        {/* Top scrollbar - only show when table is scrollable */}
        {isCompaniesTableScrollable && (
          <div 
            className="top-scrollbar-container" 
            ref={topScrollbarRef}
            onScroll={handleTopScrollbarScroll}
          >
            <div 
              className="top-scrollbar-content" 
              ref={topScrollbarContentRef}
            ></div>
          </div>
        )}
        <div className="table-wrapper" ref={tableWrapperRef}>
          <div
            className="table-container"
            onScroll={handleTableScroll}
            ref={tableContainerRef}
          >
            <div className="scroll-indicator left-scroll" ref={leftScrollIndicatorRef}>
              <span></span>
            </div>
            <div className="scroll-indicator right-scroll" ref={rightScrollIndicatorRef}>
              <span></span>
            </div>
            <table className="data-table">
              <thead>
                <tr>
                  <th>Company Name</th>
                  <th>Empty Court Details</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Status</th>
                  <th>Users</th>
                  <th>Branches</th>
                  <th>Sync Actions</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {(activeTab === "companies" ? filteredCompanies : companies).map(
                  (company) => (
                    <tr
                      key={company._id}
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        if (
                          e.target.closest(".table-actions") ||
                          e.target.closest("button")
                        )
                          return;
                        navigate(`/home/superadmin/companydetails/${company._id}`);
                      }}
                    >
                      <td>
                        <div className="table-cell-with-badge">
                          <span>{company.companyName}</span>
                        </div>
                      </td>
                      <td>
                        {requiresAction(company) ? (
                          <span className="action-required-badge table-badge">
                            Required
                          </span>
                        ) : (
                          <div>--</div>
                        )}
                      </td>
                      <td>{company.email}</td>
                      <td>{company.phno}</td>
                      <td>
                        <button
                          className={`status-toggle-btn ${company.isActive ? "active" : "inactive"
                            }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleStatusToggle(company._id, company.isActive);
                          }}
                        >
                          {company.isActive ? "Active" : "Inactive"}
                        </button>
                      </td>
                      <td>{company.users?.length || 0}</td>
                      <td>{company.branches?.length || 0}</td>
                      <td>
                        <div className="table-sync-actions">
                          <button
                            className="sync-btn-small high-court-sync"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleHighCourtSync(company._id);
                            }}
                            disabled={
                              syncingCompanies.has(company._id) ||
                              processingCompanies.has(company._id)
                            }
                          >
                            {syncingCompanies.has(company._id) ? (
                              "Syncing..."
                            ) : processingCompanies.has(company._id) ? (
                              "Processing..."
                            ) : (
                              <div className="court-tooltip-wrapper">
                                {/* <FaUniversity size={16} /> */}
                                HC
                                <span className="court-tooltip">High Court</span>
                              </div>
                            )}
                          </button>
                          <button
                            className="sync-btn-small district-court-sync"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDistrictCourtSync(company._id);
                            }}
                            disabled={
                              syncingDistrictCourtCompanies.has(company._id) ||
                              processingDistrictCourtCompanies.has(company._id)
                            }
                          >
                            {syncingDistrictCourtCompanies.has(company._id) ? (
                              "Syncing..."
                            ) : processingDistrictCourtCompanies.has(
                              company._id
                            ) ? (
                              "Processing..."
                            ) : (
                              <div className="court-tooltip-wrapper">
                                {/* <MdAccountBalance size={16} /> */}
                                DC
                                <span className="court-tooltip">
                                  District Court
                                </span>
                              </div>
                            )}
                          </button>
                        </div>
                      </td>
                      <td>{renderTableActions("company", company._id)}</td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        </div>
        {(companiesPagination.total > companiesPagination.limit || companiesPagination.page > 0) && (
          <div className="pagination-controls">
            <button
              disabled={companiesPagination.page === 0}
              onClick={() => handleCompaniesPageChange(0)}
            >
              First
            </button>
            <button
              disabled={companiesPagination.page === 0}
              onClick={() => handleCompaniesPageChange(companiesPagination.page - 1)}
            >
              Previous
            </button>
            <span>
              Page {companiesPagination.page + 1} of {Math.ceil(companiesPagination.total / companiesPagination.limit)}
            </span>
            <button
              disabled={companiesPagination.page >= Math.ceil(companiesPagination.total / companiesPagination.limit) - 1}
              onClick={() => handleCompaniesPageChange(companiesPagination.page + 1)}
            >
              Next
            </button>
            <button
              disabled={companiesPagination.page >= Math.ceil(companiesPagination.total / companiesPagination.limit) - 1}
              onClick={() => handleCompaniesPageChange(Math.ceil(companiesPagination.total / companiesPagination.limit) - 1)}
            >
              Last
            </button>
          </div>
        )}
      </>
    );
  };

  const renderContent = () => {
    if (viewMode === "card") {
      switch (activeTab) {
        case "plans":
          return renderPlansCard();
        case "users":
          return renderUsersCard();
        case "companies":
          return renderCompaniesCard();
        default:
          return null;
      }
    } else {
      switch (activeTab) {
        case "plans":
          return renderPlansTable();
        case "users":
          return renderUsersTable();
        case "companies":
          return renderCompaniesTable();
        default:
          return null;
      }
    }
  };
  const renderPlansTable = () => {
    if (plans.length === 0) {
      return (
        <div className="no-results">
          <p>No Plans Found.</p>
        </div>
      );
    }
    return (
      <>
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Price</th>
              <th>Duration</th>
              <th>Cases</th>
              <th>Users</th>
              <th>Type</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {(activeTab === "plans" ? filteredPlans : plans).map((plan) => (
              <tr
                className="plan-row"
                key={plan._id}
                onClick={() =>
                  navigate(`/home/superadmin/plandetails/${plan._id}`)
                }
                style={{ cursor: "pointer" }}
              >
                <td>{plan.name}</td>
                <td>₹{plan.price?.toLocaleString()}</td>
                <td>{plan.duration} days</td>
                <td>{plan.casesLimit || plan.caseLimit}</td>
                <td>{plan.usersLimit || plan.userLimit}</td>
                <td>{plan.type?.toUpperCase()}</td>
                <td>{renderTableActions("plan", plan._id)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* {activeTab === "plans" &&
          filteredPlans.length === 0 &&
          plans.length > 0 && (
            <div className="no-results">
              <p>No plans match the selected filters.</p>
              <button onClick={clearAllFilters} className="clear-filters-btn">
                Clear Filters
              </button>
            </div>
          )} */}
      </>
    );
  };

  return (
    <>
      {/* Loading is now handled globally by LoadingContext */}
      <>
        <div className="super-admin-module">
          <h1>Super Admin Dashboard</h1>
          {renderTabs()}
          {renderHeader()}
          {renderFilterDropdown()}
          <div className="tab-content">{renderContent()}</div>
        </div>
        <ConfirmationModal
          isOpen={isModalOpen}
          //message="Are you sure you want to scrape High  Court data for this company?"
          message={
            <>
              Are you sure you want to scrape High
              <br />
              Court data for this company?
            </>
          }
          onConfirm={handleSyncConfirm}
          onCancel={handleSyncCancel}
        />
        <ConfirmationModal
          isOpen={statusModal.isOpen}
          message={`Are you sure you want to ${statusModal.currentStatus ? "deactivate" : "activate"
            } this company?`}
          onConfirm={handleStatusConfirm}
          onCancel={handleStatusCancel}
        />
        <ConfirmationModal
          isOpen={userStatusModal.isOpen}
          message={`Are you sure you want to ${userStatusModal.currentStatus ? "deactivate" : "activate"
            } this user?`}
          onConfirm={handleUserStatusConfirm}
          onCancel={handleUserStatusCancel}
        />
        <ConfirmationModal
          isOpen={isDistrictCourtModalOpen}
          message="Are you sure you want to scrape District Court data for this company?"
          onConfirm={handleDistrictCourtSyncConfirm}
          onCancel={handleDistrictCourtSyncCancel}
        />
        <DeleteConfirmationModal
          isOpen={deleteModal.isOpen}
          itemType={deleteModal.type}
          onConfirm={handleDeleteConfirm}
          onCancel={handleDeleteCancel}
        />
        <CompanySelectionModal
          isOpen={isCompanySelectionModalOpen}
          onClose={() => setIsCompanySelectionModalOpen(false)}
          onSelectCompany={handleCompanySelect}
        />
        <CompanyLimitModal
          isOpen={isCompanyModalOpen}
          onClose={() => {
            setIsCompanyModalOpen(false);
            setSelectedCompanyForManage(null);
          }}
          selectedCompany={selectedCompanyForManage}
          companyId={selectedCompanyForManage?._id}
          selectedRefs={persistedSelectedRefs}
          setSelectedRefs={setPersistedSelectedRefs}
        />
      </>
    </>
  );
};
